import styled from '@emotion/styled';
import { MOBILE_BREAK_POINT } from '../Block.styled';

export const StoryItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 38px;

  background-color: transparent;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 345px;
  height: 338px;
`;

export const ImageBackground = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
`;

export const Title = styled.div`
  width: 100%;
  text-align: center;
  font-size: 26px;
  color: #f5c1c1;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

export const Statement = styled.p`
  font-size: 18px;
  color: white;

  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    font-size: 16px;
  }
`;
